"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractStore = void 0;
var AbstractDestroyable_1 = require("../gc/AbstractDestroyable");
var Revive_1 = require("./Revive");
var Store_1 = require("./Store");
var AbstractStore = /** @class */ (function (_super) {
    __extends(AbstractStore, _super);
    function AbstractStore() {
        var _this = _super.call(this) || this;
        _this.observers = new Set();
        _this.hooks = [];
        _this.burden(function () { return _this.observers.clear(); });
        _this.useHooks();
        return _this;
    }
    AbstractStore.prototype.getState = function () {
        return this.state;
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    AbstractStore.prototype.observe = function (a, b) {
        var _this = this;
        if (b)
            return this.observe((0, Store_1.pathObserver)(a, b));
        this.observers.add(a);
        return function () { return _this.unobserve(a); };
    };
    AbstractStore.prototype.unobserve = function (observer) {
        return this.observers.delete(observer);
    };
    AbstractStore.prototype.readonly = function () {
        return this;
    };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    AbstractStore.prototype.useHooks = function () {
    };
    AbstractStore.prototype.hook = function (h) {
        this.hooks.push(h);
    };
    AbstractStore.prototype.updateState = function (input, opts) {
        var _this = this;
        if (opts === void 0) { opts = {}; }
        if (typeof (input) !== 'function') {
            return this.updateState(function (next) { return Object.assign(next, input); }, opts);
        }
        return this.applyState(Revive_1.Revive.produce(this.state, function (draft) {
            input(draft);
            if (opts.hooks !== false) {
                _this.applyHooks(draft);
            }
        }), opts.notify !== false);
    };
    AbstractStore.prototype.setState = function (newState, opts) {
        var _this = this;
        if (opts === void 0) { opts = {}; }
        return this.applyState(Revive_1.Revive.produce(this.state, function () {
            if (opts.hooks !== false) {
                _this.applyHooks(newState);
            }
            return newState;
        }), opts.notify !== false);
    };
    AbstractStore.prototype.applyHooks = function (toState) {
        this.hooks.forEach(function (h) { return h(toState); });
        return toState;
    };
    AbstractStore.prototype.applyState = function (newState, notify) {
        var oldState = this.state;
        this.state = newState;
        if (notify) {
            this.observers.forEach(function (x) { return x(newState, oldState); });
        }
        return oldState;
    };
    return AbstractStore;
}(AbstractDestroyable_1.AbstractDestroyable));
exports.AbstractStore = AbstractStore;
